/* eslint-disable */
import axios from 'axios';
import { isDebug } from '../main.js';
export default {
  replaceImg(src) {
    return (
      src.replace('cos.ap-guangzhou', 'picgz') + `?imageMogr2/format/jpg|imageMogr2/quality/20`
    );
  },

  upLoad(item_type, action_type, item_id ) {
    // let url = "https://tapp.tfgreenroad.com";  // 测试环境
    let url = isDebug?"https://tapp.tfgreenroad.com":"https://app-cdc.tfgreenroad.com";  // 正式环境
    axios({
      method: 'post',
      url: `${url}/appserver/v1/user/user_behavior?item_type=${item_type}&action_type=${action_type}&item_id=${item_id}`,
      // url: `https://tgr.wiiqq.com/appserver/v1/user/user_behavior?item_type=${item_type}&action_type=${action_type}&trace_id=${trace_id}`,
      data: {
        // item_id:item_id,
        item_type: Number(item_type),
        action_type: action_type,
        item_id : item_id ,
        // action_value:action_value,
      },
      headers: {
        latitude: sessionStorage.getItem('realLat') || 30.575045991831505 ,
        longitude: sessionStorage.getItem('realLng') || 104.05059712158203 ,
      },
    }).then(res => {
      // console.log(res,1);
    });
  },
};
